<div class="modal-header">
    <div class="row header-row">
        <div class="col-md-5 col-sm-12">
            <h6 class="modal-title pull-left"> <span class="back" (click)="back()"> <i class="fas fa-arrow-left"> </i>
                    &nbsp;
                    Back</span>User Details</h6>
        </div>
    </div>
</div>
<div class="modal-body">
    <div class="sect">
        <div class="title-head"> User Details</div>

        <div class="row data-info">
            <div class="col-md-4 col-sm-12"><span>Day: </span>{{addUserObj.day}}</div>
            <div class="col-md-4 col-sm-12"><span>Date: </span>{{addUserObj.day_1_date }}</div>
            <div class="col-md-4 col-sm-12"><span>User Name: </span>{{addUserObj.user_name}}</div>
        </div>

        <div class="row data-info">
            <div class="col-md-4 col-sm-12"> <span>Event: </span>{{addUserObj.org_name}}</div>
            <div class="col-md-4 col-sm-12"><span>User Role:
                </span>{{addUserObj.user_role==1?'Speaker':addUserObj.user_role==2?"Delegate":addUserObj.user_role==3?"AFGG":'-NA-'}}
            </div>
        </div>
    </div>

    <div  class="sect">
        <div class="title-head">Assigned Gate</div>
        <div class="row data-info">
            <div class="col-md-12 col-sm-12" id="agenda" > <span>Breakfast: </span>{{ addUserObj.breakfast_gate_name!='undefined'?addUserObj.breakfast_gate_name:'-NA-'}}</div>
            <div class="col-md-12 col-sm-12" id="agenda" > <span>Lunch: </span>{{addUserObj.lunch_gate_name!='undefined'?addUserObj.lunch_gate_name:'-NA-'}}</div>
            <div class="col-md-12 col-sm-12" id="agenda" > <span>Dinner: </span>{{addUserObj.dinner_gate_name!='undefined'?addUserObj.dinner_gate_name:'-NA-'}}</div>
            <div class="col-md-12 col-sm-12" id="agenda" > <span>Conversations over Kahwa: </span>{{addUserObj.tea_gate_name!='undefined'?addUserObj.tea_gate_name:'-NA-'}}</div>
        </div>
    </div>
    <div *ngIf="addUserObj.user_role==1" class="sect">
        <div class="title-head"> Speaking Engagement</div>
        <div class="row data-info">
            <div class="col-md-4 col-sm-12" id="agenda" [innerHtml]="speaking_engagement"></div>
        </div>
    </div>

    <div class="sect">
        <div class="title-head"> Agenda</div>
        <div class="row data-info">
            <div class="col-md-4 col-sm-12" id="agenda" [innerHtml]="agenda"></div>
        </div>
    </div>

    <div class="sect">
        <div class="title-head"> Dining</div>
        <div class="row data-info">
            <div class="col-md-4 col-sm-12" id="agenda" [innerHtml]="dinning"></div>
        </div>
    </div>

</div>
<div>
</div>